module.exports = __webpack_public_path__ + "img/pumping-activities-circle.feaf69c0.png";